import { FormElems, Table, TableFilter } from 'components';

// Importing Libs
import {
    fetchMerchantLegalEntityDetailsRequest,
    fetchMerchantLegalEntityRequest,
    removeRedirectKey,
    resetFormDataMLE,
    resetMerchantLegalEntityFormReset,
    clearMerchantLegalEntityDetails,
} from './redux/merchantLegalEntity.actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import React, { useMemo, useState, useCallback, useEffect } from 'react';
import { useHistory, withRouter } from 'react-router-dom';
import moment from 'moment';
import { BUSINESSDETAILS, UBODETAILS } from './constants';
import MleDraftAction from './MleDraftAction';
import { toast } from 'react-toastify';

const pageSizeOptions = [10, 20, 40, 60, 100, 1000];

const filterFieldList = [
    {
        fieldType: 'date',
        label: 'Date Range',
        name: 'createdOn',
        props: {
            startDate: moment()
                .endOf('day')
                .subtract(1825, 'days'),
            endDate: moment().endOf('day'),
            maximumNights: 365,
            notResetDate: true,
        },
    },
    {
        fieldType: 'input',
        label: 'MLE ID',
        name: 'merchantId',
        props: {
            placeholder: 'Enter ID',
        },
    },
    {
        fieldType: 'input',
        label: 'MLE NAME',
        name: 'name',
        props: {
            placeholder: 'Enter name',
        },
    },
    {
        fieldType: 'select',
        label: 'Enterprise Merchant',
        name: 'enterprise_merchant',
        props: {
            data: [
                { name: 'Yes', entityCode: 'yes' },
                { name: 'No', entityCode: 'no' }
            ],
            label: 'Please Select',
            labelField: 'name',
            valueField: 'entityCode',
        },
    },
    // {
    //     fieldType: 'select',
    //     label: 'Onboarding Type',
    //     name: 'source',
    //     props: {
    //         placeholder: 'Select Onboarding Type',
    //         data: [
    //             { name: 'Axis Sourced MLE', value: 'axis' },
    //             { name: 'Others', value: 'other' },
    //         ],
    //         label: 'Select Onboarding Type',
    //         labelField: 'name',
    //         valueField: 'value',
    //     },
    // },
];

const MleUserActions = ({ data, history ,auth, actions}) => {
    const handleEditView = actionType => {
        const { entityCode } = data.original;
        // actions.fetchMerchantLegalEntityDetailsRequest({ entityCode });

        // actions.fetchMerchantLegalEntityRequest({entityCode});

        if (actionType === 'edit') {
            history.push(`/mle-onboarding/edit/${BUSINESSDETAILS}/${entityCode}`);
        } else if (actionType === 'view') {
            history.push(`/mle-onboarding/view/${BUSINESSDETAILS}/${entityCode}`);
        }
    };
    const hasCreatePermission = auth?.resourceDetails?.permissions?.merchant_onboarding?.includes('create mle');
    const hasEditPermission = auth?.resourceDetails?.permissions?.edit_merchant_onboarding?.includes('update_mle');
    const hasViewPermission = auth?.resourceDetails?.permissions?.edit_merchant_onboarding?.includes('fetch_mle');
    
    const handleEditClick =() =>{
        toast.error('Access Denied. User doesnt have required permissions. Please contact support.')
    }
    return (
        <div className="userAction  multiItem">
            <>
            {(hasCreatePermission || hasEditPermission) && (
                        <button
                            className="edit"
                            id="edit-merchant"
                            onClick={() => handleEditView('edit')}
                        />
                    )}

            {hasViewPermission &&( !hasCreatePermission && !hasEditPermission) && (
                        <button
                            className="edit"
                            id="view-only-merchant"
                            onClick={handleEditClick}
                        />
                       
                    )}
                    <button
                            className="view"
                            id="view-merchant"
                            onClick={() => handleEditView('view')}
                    />
            </>
        </div>
    );
};

MleUserActions.propTypes = {
    data: PropTypes.object.isRequired,
    history: PropTypes.object,
};

const DownloadActions = ({ handleDownloadClick }) => {
    return (
        <div className="userAction draft-action" id="download-action">
            <FormElems.Button
                buttonType="secondary"
                text="Download"
                type="button"
                handleClick={handleDownloadClick}
            />
        </div>
    );
};

DownloadActions.propTypes = {
    handleDownloadClick: PropTypes.object.isRequired,
};

const MerchantLegalEntityTable = ({ merchantLegalEntityData, actions, auth }) => {
    const [pageCount, setPageCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [filterData, setFilterData] = useState({});
    const [isResetPage, setIsResetPage] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [roleStatus, setRoleStatus] = useState('');
    const history = useHistory();
    

    const { error, tableData, isLoading, pagination } = merchantLegalEntityData;
    
    useEffect(() => {
        setPageCount(Math.ceil(pagination.totalNumberOfRecords / pageSize));
    }, [actions, pageSize, pagination.totalNumberOfRecords]);

    useEffect(() => {
        actions.resetMerchantLegalEntityFormReset();
        actions.clearMerchantLegalEntityDetails();
    }, []);

    function convertToCSV(arr) {
        const array = [Object.keys(arr[0])].concat(arr);

        return array
            .map(it => {
                return Object.values(it).toString();
            })
            .join('\n');
    }

    // Function to download data as CSV
    function downloadCSV(data, filename = 'data.csv') {
        const csv = convertToCSV(data);
        const blob = new Blob([csv], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.setAttribute('href', url);
        a.setAttribute('download', filename);
        a.click();
    }

    const handleDownloadClick = () => {
        downloadCSV(tableData, `MLE_${new Date().getTime()}.csv`);
    };

    const columns = useMemo(
        () => [
            { header: 'Entity Name', accessor: 'entityName' },
            { header: 'MLE Id', accessor: 'entityCode' },
            { header: 'Created Date', accessor: 'createdDate' },
            { header: 'MLE Status', accessor: 'entityStatus' },
            { header: 'KYC Status', accessor: 'kycStatus' },
            {
                header: 'Relationship Manager',
                accessor: 'relationshipManagerId',
            },
            { header: 'Action', accessor: 'action' },
        ],
        []
    );

    const fetchData = useCallback(
        ({ pageSize, pageIndex, roleStatus, appliedFilters }) => {
            // This will get called when the table needs new data
            // You could fetch your data from literally anywhere,
            const data = { pageSize, pageIndex, roleStatus };
            if (filterData.createdOn) {
                actions.fetchMerchantLegalEntityRequest({
                    ...data,
                    ...appliedFilters,
                    ...filterData,
                });
            }
            setPageSize(pageSize);
        },
        [actions, filterData]
    );

    return (
        <>
        <div className="checker-wrapper">
            <Table
                tableTitle="MLE Onboarding"
                columns={columns}
                isFiltersEnable
                isPaginationEnable
                data={tableData}
                filterData={filterData}
                error={error && error.errorMessage}
                roleStatus={roleStatus}
                //        loading={showLoader || isLoading}
                pageCount={pageCount}
                fetchData={fetchData}
                numberOfRecord={pagination.totalNumberOfRecords}
                pageSizeOptions={pageSizeOptions}
                paginationLabel="Rows per page"
                pagePerView={3}
                isResetPage={isResetPage}
                afterResetPage={() => setIsResetPage(false)}
                userActions={data => (
                    <MleUserActions data={data} history={history} actions={actions} auth={auth} />
                )}
                additionalActions={props => (
                    <>
                    <MleDraftAction />
                    <DownloadActions
                        handleDownloadClick={handleDownloadClick}
                    />
                    </>
                )}
                tableFilters={
                    <TableFilter
                        customFilterClass="rightSkewed"
                        showOverlay
                        fieldsList={filterFieldList}
                        onSubmit={filterValues => {
                            setFilterData(filterValues);
                            setIsResetPage(true);
                        }}
                        onReset={resetValue => {
                            setFilterData({
                                ...resetValue,
                            });
                            setIsResetPage(true);
                        }}
                    />
                }
                filterActionPermission="create mle"
                filterActionTitle="Create New MLE"
                onClickTableAction={() => {
                     
                    let isClickable = true;
                    if (!auth?.resourceDetails?.permissions?.mle_onboarding) {
                        isClickable = false;
                    } else if (auth?.resourceDetails?.permissions?.mle_onboarding && typeof auth.resourceDetails.permissions.mle_onboarding === 'object') {
                        const isPermissionExist = Object.values(auth?.resourceDetails?.permissions?.mle_onboarding).join('').includes('mle_maker')
                        
                        isClickable = isPermissionExist;
                    }
                    
                    if (!isClickable) {
                        
                        toast.error("You do not have permission to access this resource.");
                        return;
                    }
                    actions.resetFormDataMLE();
                    history.push(`/mle-onboarding/create/${BUSINESSDETAILS}`);
                }}
                loading={isLoading}
            />
        </div>
        </>
    );
};

MerchantLegalEntityTable.propTypes = {
    actions: PropTypes.object,
    auth: PropTypes.object,
    data: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    merchantLegalEntityData: PropTypes.object,
    editData: PropTypes.object,
    loader: PropTypes.object,
};

const mapStateToProps = ({ auth, merchantLegalEntityData }) => ({
    auth,
    merchantLegalEntityData,
});

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(
        {
            fetchMerchantLegalEntityRequest,
            resetMerchantLegalEntityFormReset,
            resetFormDataMLE,
            fetchMerchantLegalEntityDetailsRequest,
            removeRedirectKey,
            clearMerchantLegalEntityDetails,
        },
        dispatch
    ),
});

export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(MerchantLegalEntityTable)
);
